/*!
 * ╔══════════════════════════════════════════════════════════════╗
 * ║              AURI Luxury Theme — theme.js v2.1              ║
 * ╠══════════════════════════════════════════════════════════════╣
 * ║  Developed by: Echo Digital Agency                          ║
 * ║  WhatsApp:     +20 10 0067 0867                             ║
 * ║  Client:       AURI — auri-eg.com                           ║
 * ║  Year:         2025 — 2026                                  ║
 * ║  © Echo Agency. All rights reserved.                        ║
 * ╚══════════════════════════════════════════════════════════════╝
 */

/* ══════════════════════════════════════════════════════════════
   CART DRAWER — كل الوظائف بتاعة الدرج الجانبي
   ══════════════════════════════════════════════════════════════ */

var _drawerOpen = false;

/* فتح الدرج */
function openCartDrawer() {
  var drawer  = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  if (!drawer) return;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  overlay.classList.add('active');
  overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  _drawerOpen = true;
  loadCartDrawer();
}

/* إغلاق الدرج */
function closeCartDrawer() {
  var drawer  = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  if (!drawer) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  overlay.classList.remove('active');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  _drawerOpen = false;
}

/* تحميل بيانات الكارت من Shopify وعرضها في الدرج */
function loadCartDrawer() {
  var body   = document.getElementById('cart-drawer-body');
  var footer = document.getElementById('cart-drawer-footer');
  if (!body) return;

  body.innerHTML = '<div class="cart-drawer__loading"><div class="cart-drawer__spinner"></div></div>';
  if (footer) footer.style.display = 'none';

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartBody(cart);
      renderCartFooter(cart);
      auriUpdateCartCount(cart.item_count);
    })
    .catch(function() {
      body.innerHTML = '<p style="padding:40px 24px;text-align:center;color:#9ca3af;font-size:13px">Could not load cart. Please try again.</p>';
    });
}

/* رسم محتوى الجسم */
function renderCartBody(cart) {
  var body = document.getElementById('cart-drawer-body');
  var lbl  = document.getElementById('cd-count-label');
  if (!body) return;

  if (lbl) lbl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

  if (!cart.items || cart.items.length === 0) {
    body.innerHTML = [
      '<div class="cart-drawer__empty">',
        '<div class="cart-drawer__empty-icon">',
          '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
        '</div>',
        '<p class="cart-drawer__empty-title">Your bag is empty</p>',
        '<p class="cart-drawer__empty-sub">Add your favourite pieces to get started.</p>',
        '<a href="/collections/all" class="cart-drawer__empty-btn" onclick="closeCartDrawer()">Shop Now</a>',
      '</div>'
    ].join('');
    return;
  }

  var html = cart.items.map(function(item) {
    var img = item.featured_image && item.featured_image.url
      ? item.featured_image.url.replace(/\.jpg|\.png|\.webp/, function(m) { return '_80x96_crop_center' + m; })
      : '';
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
      : '';
    return [
      '<div class="cart-drawer__item" data-key="' + item.key + '">',
        img ? '<img class="cart-drawer__item-img" src="' + img + '" alt="' + item.title + '" loading="lazy">'
            : '<div class="cart-drawer__item-img" style="background:#f0eee9"></div>',
        '<div class="cart-drawer__item-info">',
          '<p class="cart-drawer__item-name">' + item.product_title + '</p>',
          variantLine,
          '<p class="cart-drawer__item-price">' + formatMoneyDrawer(item.line_price) + '</p>',
          '<div class="cart-drawer__item-actions">',
            '<div class="cd-qty">',
              '<button class="cd-qty__btn" onclick="cdUpdateQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>',
              '<span class="cd-qty__val">' + item.quantity + '</span>',
              '<button class="cd-qty__btn" onclick="cdUpdateQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>',
            '</div>',
            '<button class="cd-remove" onclick="cdRemoveItem(\'' + item.key + '\')">Remove</button>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');
  }).join('');

  body.innerHTML = html;
}

/* رسم الفوتر (السعر الكلي + زرار الـ Checkout) */
function renderCartFooter(cart) {
  var footer = document.getElementById('cart-drawer-footer');
  if (!footer) return;

  if (!cart.items || cart.items.length === 0) {
    footer.style.display = 'none';
    return;
  }

  footer.style.display = 'block';
  footer.innerHTML = [
    '<div class="cart-drawer__subtotal">',
      '<span class="cart-drawer__subtotal-label">Subtotal</span>',
      '<span class="cart-drawer__subtotal-val">' + formatMoneyDrawer(cart.total_price) + '</span>',
    '</div>',
    '<p class="cart-drawer__note">Shipping & taxes calculated at checkout</p>',
    '<a href="/checkout" class="cart-drawer__checkout">Proceed to Checkout →</a>',
    '<a href="/cart" class="cart-drawer__view-cart">View full cart</a>'
  ].join('');
}

/* تحديث كمية عنصر في الكارت */
window.cdUpdateQty = function(key, qty) {
  if (qty < 0) qty = 0;
  fetch('/cart/change.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body:    JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    renderCartBody(cart);
    renderCartFooter(cart);
    auriUpdateCartCount(cart.item_count);
  })
  .catch(function() { auriToast('Could not update cart.', 'error'); });
};

/* حذف عنصر من الكارت */
window.cdRemoveItem = function(key) {
  cdUpdateQty(key, 0);
};

/* تنسيق السعر (Shopify بيبعته بالهللات) */
function formatMoneyDrawer(cents) {
  var amount = (cents / 100).toFixed(2);
  return 'EGP ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}


/* ══════════════════════════════════════════════════════════════
   SHOPIFY AJAX CART — إضافة منتجات بدون reload
   ══════════════════════════════════════════════════════════════ */

window.addToCartQuick = function(event, variantId) {
  event.preventDefault();
  event.stopPropagation();

  var btn = event.currentTarget || event.target;
  if (!btn || btn.disabled) return;

  var vid = parseInt(variantId, 10);
  if (!vid) return;

  var origHTML = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:5px">'
    + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="auri-spin"><path d="M21 12a9 9 0 1 1-18 0"/></svg>'
    + 'Adding…</span>';

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body:    JSON.stringify({ id: vid, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status === 422 || data.description) {
      auriToast(data.description || 'Could not add to cart.', 'error');
      btn.disabled = false;
      btn.innerHTML = origHTML;
      return;
    }
    /* نجح — اعرض علامة التأكيد وافتح الدرج */
    btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:5px">'
      + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>'
      + 'Added!</span>';
    btn.classList.add('added');

    openCartDrawer();

    setTimeout(function() {
      btn.disabled = false;
      btn.innerHTML = origHTML;
      btn.classList.remove('added');
    }, 2000);
  })
  .catch(function() {
    auriToast('Something went wrong. Please try again.', 'error');
    btn.disabled = false;
    btn.innerHTML = origHTML;
  });
};

/* تحديث عداد الكارت في الهيدر */
function auriUpdateCartCount(count) {
  if (typeof count !== 'number') {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(c) { auriUpdateCartCount(c.item_count); })
      .catch(function() {});
    return;
  }
  document.querySelectorAll('.cart-count').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

/* Toast notification */
function auriToast(msg, type) {
  var t = document.createElement('div');
  t.textContent = msg;
  t.style.cssText = [
    'position:fixed','top:80px','left:50%','transform:translateX(-50%)',
    'z-index:99999','padding:12px 24px','font-size:13px','font-weight:600',
    'letter-spacing:.04em','border-radius:2px',
    'box-shadow:0 4px 20px rgba(0,0,0,.18)','transition:opacity .3s',
    type === 'success' ? 'background:#FACC15;color:#1a1a1a;' : 'background:#dc2626;color:#fff;'
  ].join(';');
  document.body.appendChild(t);
  setTimeout(function() { t.style.opacity = '0'; }, 2200);
  setTimeout(function() { if (t.parentNode) t.parentNode.removeChild(t); }, 2600);
}

/* أيقونة الدوران */
var spinStyle = document.createElement('style');
spinStyle.textContent = '@keyframes auri-spin{to{transform:rotate(360deg)}}.auri-spin{animation:auri-spin .7s linear infinite}';
document.head.appendChild(spinStyle);


/* ══════════════════════════════════════════════════════════════
   ADD-TO-CART في صفحة المنتج (product form)
   ══════════════════════════════════════════════════════════════ */

function initProductForm() {
  var productForm = document.getElementById('product-form');
  if (!productForm) return;

  productForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var vid = document.getElementById('variant-id') && document.getElementById('variant-id').value;
    var qty = productForm.querySelector('[name="quantity"]') ? productForm.querySelector('[name="quantity"]').value : 1;
    var btn = document.getElementById('add-to-cart-btn');
    if (!vid || !btn || btn.disabled) return;

    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: parseInt(vid, 10), quantity: parseInt(qty, 10) })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status === 422 || data.description) {
        auriToast(data.description || 'Could not add to cart.', 'error');
        btn.disabled = false;
        btn.textContent = origText;
        return;
      }
      btn.textContent = 'Added ✓';
      btn.classList.add('added');
      openCartDrawer();
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = origText;
        btn.classList.remove('added');
      }, 2200);
    })
    .catch(function() {
      auriToast('Something went wrong. Please try again.', 'error');
      btn.disabled = false;
      btn.textContent = origText;
    });
  });
}


/* ══════════════════════════════════════════════════════════════
   VARIANT SELECTION — تحديث السعر والـ variant ID عند الاختيار
   ══════════════════════════════════════════════════════════════ */

function initVariantSelection() {
  var variantDataEl = document.getElementById('product-variants-json');
  if (!variantDataEl) return;
  var variants = JSON.parse(variantDataEl.textContent || '[]');
  var variantInput = document.getElementById('variant-id');
  var addBtn = document.getElementById('add-to-cart-btn');
  var priceEl = document.querySelector('.product-info__price [itemprop="price"]');
  var buttons = Array.from(document.querySelectorAll('.product-info .variant-btn, .product-info .color-swatch'));
  var selectedOpts = {};
  var colorPositions = {};
  buttons.forEach(function(btn) {
    if (btn.classList.contains('color-swatch')) colorPositions[btn.dataset.option] = true;
  });
  function selectVariant(v) {
    if (!v) return;
    [1, 2, 3].forEach(function(pos) { if (v['option' + pos] != null) selectedOpts[pos] = v['option' + pos]; });
  }
  var initial = variants.find(function(v) { return variantInput && String(v.id) === variantInput.value; });
  selectVariant(initial || variants.find(function(v) { return v.available; }) || variants[0]);
  function findVariant() {
    return variants.find(function(v) {
      return Object.keys(selectedOpts).every(function(pos) { return v['option' + pos] === selectedOpts[pos]; });
    });
  }
  function updateUI() {
    var v = findVariant();
    buttons.forEach(function(btn) {
      var pos = btn.dataset.option;
      var isColor = !!colorPositions[pos];
      var available = variants.some(function(candidate) {
        if (!candidate.available || candidate['option' + pos] !== btn.dataset.value) return false;
        return Object.keys(selectedOpts).every(function(otherPos) {
          if (otherPos === pos || (isColor && !colorPositions[otherPos])) return true;
          return candidate['option' + otherPos] === selectedOpts[otherPos];
        });
      });
      var selected = selectedOpts[pos] === btn.dataset.value;
      btn.disabled = !available;
      btn.classList.toggle(isColor ? 'color-swatch--sold-out' : 'variant-btn--sold-out', !available);
      btn.classList.toggle(isColor ? 'color-swatch--active' : 'selected', selected);
      btn.setAttribute('aria-pressed', String(selected));
      btn.setAttribute('aria-label', btn.dataset.value + (available ? '' : ' — Sold Out'));
    });
    var colorLabel = document.getElementById('active-color-label');
    if (colorLabel) {
      var colorPos = Object.keys(colorPositions)[0];
      colorLabel.textContent = selectedOpts[colorPos] || '';
    }
    if (variantInput) variantInput.value = v ? v.id : '';
    if (priceEl && v) {
      priceEl.textContent = 'EGP ' + (v.price / 100).toFixed(2);
      priceEl.setAttribute('content', (v.price / 100).toFixed(2));
    }
    var available = !!(v && v.available);
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.setAttribute('aria-disabled', String(!available));
      addBtn.textContent = available ? 'Add to Bag' : 'Sold Out';
    }
    var stock = document.querySelector('.product-info [aria-label="In stock"], .product-info [aria-label="Out of stock"]');
    if (stock) {
      stock.setAttribute('aria-label', available ? 'In stock' : 'Out of stock');
      stock.style.background = available ? '#f0fdf4' : '#f3f4f6';
      stock.style.borderColor = available ? '#bbf7d0' : '#e5e7eb';
      stock.style.color = available ? '#15803d' : '#6b7280';
      if (stock.firstElementChild) stock.firstElementChild.style.background = available ? '#22c55e' : '#9ca3af';
      if (stock.lastChild && stock.lastChild.nodeType === 3) stock.lastChild.textContent = available ? ' In Stock' : ' Out of Stock';
    }
  }
  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      var pos = btn.dataset.option;
      var val = btn.dataset.value;
      if (!pos || !val) return;
      selectedOpts[pos] = val;
      var v = findVariant();
      if (colorPositions[pos] && (!v || !v.available)) {
        selectVariant(variants.find(function(candidate) {
          return candidate.available && Object.keys(colorPositions).every(function(colorPos) {
            return candidate['option' + colorPos] === selectedOpts[colorPos];
          });
        }));
      }
      updateUI();
    });
  });
  updateUI();
}

/* ══════════════════════════════════════════════════════════════
   DOMContentLoaded — تشغيل كل الوظائف
   ══════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  /* ── Cart Drawer: فتح / إغلاق ── */
  var openBtn  = document.getElementById('cart-drawer-open');
  var closeBtn = document.getElementById('cart-drawer-close');
  var overlay  = document.getElementById('cart-drawer-overlay');

  if (openBtn)  openBtn.addEventListener('click', openCartDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay)  overlay.addEventListener('click', closeCartDrawer);

  /* إغلاق بـ Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && _drawerOpen) closeCartDrawer();
  });

  /* ── Product Form ── */
  initProductForm();

  /* ── Variant Selection ── */
  initVariantSelection();

  /* ── Hero Slider ── */
  var hero = document.querySelector('.hero');
  if (hero) {
    var heroSlides  = hero.querySelectorAll('.hero__slide');
    var heroDots    = hero.querySelectorAll('.hero__dot');
    var heroCounter = hero.querySelector('.hero__counter');
    var heroCurrent = 0, heroTimer;

    function heroGoTo(n) {
      heroSlides[heroCurrent].classList.remove('active');
      if (heroDots[heroCurrent]) heroDots[heroCurrent].classList.remove('active');
      heroCurrent = (n + heroSlides.length) % heroSlides.length;
      heroSlides[heroCurrent].classList.add('active');
      if (heroDots[heroCurrent]) heroDots[heroCurrent].classList.add('active');
      if (heroCounter) heroCounter.textContent =
        String(heroCurrent + 1).padStart(2, '0') + ' / ' + String(heroSlides.length).padStart(2, '0');
    }
    function heroStart() { heroTimer = setInterval(function() { heroGoTo(heroCurrent + 1); }, 5500); }
    function heroReset() { clearInterval(heroTimer); heroStart(); }

    var prevBtn = hero.querySelector('.hero__arrow--prev');
    var nextBtn = hero.querySelector('.hero__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function() { heroGoTo(heroCurrent - 1); heroReset(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { heroGoTo(heroCurrent + 1); heroReset(); });
    heroDots.forEach(function(d, i) { d.addEventListener('click', function() { heroGoTo(i); heroReset(); }); });
    heroGoTo(0);
    heroStart();
  }

  /* ── Mobile Menu ── */
  var menuToggle = document.querySelector('.mobile-menu-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  var menuClose  = document.querySelector('.mobile-menu__close');
  if (menuToggle) menuToggle.addEventListener('click', function() { mobileMenu && mobileMenu.classList.add('open'); });
  if (menuClose)  menuClose.addEventListener('click',  function() { mobileMenu && mobileMenu.classList.remove('open'); });

  /* ── Search Drawer ── */
  var searchDrawer = document.querySelector('.search-drawer');
  document.querySelectorAll('[data-search-open]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (searchDrawer) {
        searchDrawer.classList.add('open');
        var inp = searchDrawer.querySelector('.search-input');
        if (inp) inp.focus();
      }
    });
  });
  var searchClose = document.querySelector('[data-search-close]');
  if (searchClose) searchClose.addEventListener('click', function() {
    if (searchDrawer) searchDrawer.classList.remove('open');
  });

  /* ── Color Swatches ── */
  var colorMap = {
    black:'#1a1a1a', white:'#f5f5f5', silver:'#c0c0c0', gold:'#d4af37',
    beige:'#e8dcc8', brown:'#7b4f2e', camel:'#c19a6b', nude:'#e8c9a8',
    red:'#dc2626',   pink:'#f472b6',  rose:'#fb7185',   coral:'#f87171',
    blue:'#3b82f6',  navy:'#1e3a5f',  green:'#16a34a',  olive:'#6b7c31',
    gray:'#9ca3af',  grey:'#9ca3af',  cream:'#f5f0e8',  tan:'#d2b48c',
    burgundy:'#800020', champagne:'#f7e7ce', leopard:'#c8963e',
    khaki:'#c3b091', orange:'#f97316', purple:'#9333ea', yellow:'#facc15'
  };
  function resolveColor(name) {
    var key = (name || '').toLowerCase().trim();
    for (var k in colorMap) { if (key.indexOf(k) !== -1) return colorMap[k]; }
    return '#9ca3af';
  }
  document.querySelectorAll('.color-swatch').forEach(function(btn) {
    btn.style.background = resolveColor(btn.dataset.color || btn.dataset.value || '');
  });
  var colorLabel = document.getElementById('active-color-label');
  document.querySelectorAll('.color-swatch').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.color-swatch').forEach(function(b) {
        b.classList.remove('color-swatch--active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('color-swatch--active');
      btn.setAttribute('aria-pressed', 'true');
      if (colorLabel) colorLabel.textContent = btn.title || btn.dataset.value || '';
    });
  });

  /* Pill buttons */
  document.querySelectorAll('.variant-options').forEach(function(group) {
    group.querySelectorAll('.variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        group.querySelectorAll('.variant-btn').forEach(function(b) {
          b.classList.remove('selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('selected');
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  });

  /* ── Cart Page qty buttons ── */
  document.querySelectorAll('.qty-selector').forEach(function(sel) {
    var inp   = sel.querySelector('.qty-input');
    var plus  = sel.querySelector('[data-plus]');
    var minus = sel.querySelector('[data-minus]');
    if (plus)  plus.addEventListener('click',  function() { inp.value = Math.max(1, parseInt(inp.value || 1) + 1); });
    if (minus) minus.addEventListener('click', function() { inp.value = Math.max(1, parseInt(inp.value || 1) - 1); });
  });

  /* تحميل عداد الكارت */
  auriUpdateCartCount();

});

/* Product-card colors: update only the card that was clicked. */
(function () {
  function paintCardColors(root) {
    var palette = {black:'#1a1a1a',white:'#d1d5db',silver:'#c0c0c0',gold:'#d4af37',beige:'#c7b698',brown:'#7b4f2e',camel:'#c19a6b',nude:'#d4ad8c',red:'#dc2626',pink:'#f472b6',rose:'#fb7185',coral:'#f87171',blue:'#3b82f6',navy:'#1e3a5f',green:'#16a34a',olive:'#6b7c31',gray:'#9ca3af',grey:'#9ca3af',cream:'#d4cbb7',tan:'#d2b48c',burgundy:'#800020',champagne:'#d8c69b',leopard:'#c8963e',khaki:'#a89b74',orange:'#f97316',purple:'#9333ea',yellow:'#eab308'};
    root.querySelectorAll('.product-card__color').forEach(function(btn) {
      var name = btn.dataset.cardColor || '';
      var key = Object.keys(palette).find(function(color) { return name.indexOf(color) !== -1; });
      var color = key ? palette[key] : '#9ca3af';
      btn.style.borderColor = color;
      btn.style.borderWidth = btn.getAttribute('aria-pressed') === 'true' ? '2px' : '1px';
      if (!btn.querySelector('img')) btn.style.background = color;
    });
  }
  document.addEventListener('click', function(event) {
    var btn = event.target.closest('.product-card__color');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var card = btn.closest('.product-card');
    if (!card) return;
    card.querySelectorAll('.product-card__color').forEach(function(other) {
      other.setAttribute('aria-pressed', String(other === btn));
    });
    var image = card.querySelector('.product-card__img');
    if (image && btn.dataset.cardImage) {
      image.srcset = btn.dataset.cardSrcset;
      image.src = btn.dataset.cardImage;
      image.alt = btn.dataset.cardAlt;
    }
    card.querySelectorAll('a').forEach(function(link) { link.href = btn.dataset.cardUrl; });
    var quick = card.querySelector('.product-card__quick');
    if (quick) {
      quick.dataset.variantId = btn.dataset.cardVariant;
      quick.disabled = btn.dataset.cardAvailable !== 'true';
      quick.setAttribute('aria-label', quick.disabled ? 'Sold Out' : 'Add to cart');
      var text = Array.from(quick.childNodes).find(function(node) { return node.nodeType === 3 && node.textContent.trim(); });
      if (text) text.textContent = quick.disabled ? 'Sold Out' : 'Add to Bag';
    }
    var price = card.querySelector('.product-card__price-current');
    if (price) price.textContent = btn.dataset.cardPrice;
    var compare = card.querySelector('.product-card__price-compare');
    if (!compare && btn.dataset.cardCompare) {
      compare = document.createElement('span');
      compare.className = 'product-card__price-compare';
      if (price) price.parentElement.appendChild(compare);
    }
    if (compare) { compare.textContent = btn.dataset.cardCompare || ''; compare.hidden = !btn.dataset.cardCompare; }
    paintCardColors(card);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { paintCardColors(document); });
  else paintCardColors(document);
  document.addEventListener('shopify:section:load', function(event) { paintCardColors(event.target); });
})();
